import { render, staticRenderFns } from "./swip_box.vue?vue&type=template&id=79fbe2ce&scoped=true&"
import script from "./swip_box.vue?vue&type=script&lang=js&"
export * from "./swip_box.vue?vue&type=script&lang=js&"
import style0 from "./swip_box.vue?vue&type=style&index=0&id=79fbe2ce&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79fbe2ce",
  null
  
)

export default component.exports